"use strict";

exports.__esModule = true;
exports.AdvancedDataTableElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _history = require("history");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _Core = require("../../Core");
var _DataTable = require("../../Core/DataTable/DataTable");
var _formatColumns = require("../../Core/DataTable/formatColumns");
var _Device = require("../../Device");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _TicketTypeListContext = require("../../TicketTypes/TicketTypeListContext");
var _TimeContext = require("../../Time/TimeContext");
var _UserListContext = require("../../User/UserListContext");
var _helpers = require("../DataTable/helpers");
var _AdvancedDataTableDataProvider = require("./AdvancedDataTableDataProvider");
var _PlantStateActivities = require("../../PlantStateActivities");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var AdvancedDataTableElement = exports.AdvancedDataTableElement = (0, _reactRouterCompat.withRouter)(function (props) {
  // Create a helper function that will be used to format a single cell value based on the column type
  var configuration = props.configuration,
    children = props.children,
    dataSource = props.dataSource,
    height = props.height,
    width = props.width,
    dataRange = props.dataRange,
    fetchDataOnlyOnSelection = props.fetchDataOnlyOnSelection;

  // contexts
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  var translator = _react["default"].useContext(_Core.TranslatorContext);
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(_react["default"].useContext(_PlantStateActivitiesContext.PlantStateActivitiesContext));
  var translate = translator.translate;
  var users = _react["default"].useContext(_UserListContext.UserListContext);
  var ticketTypes = _react["default"].useContext(_TicketTypeListContext.TicketTypeListContext);
  var devices = _react["default"].useContext(_Device.AllDeviceListContext);
  var selection = _react["default"].useContext(_Core.SelectionContext);

  // If auto is selected, calculate the rows based on the height otherwise use the given size
  var defaultPageSize = (0, _helpers.nearestIndexInPageSizeList)([5, 10, 25, 100], (0, _helpers.getDefaultPageSize)(configuration, height) < 0 ? 0 : (0, _helpers.getDefaultPageSize)(configuration, height));
  var _useState = (0, _react.useState)({
      page: 0,
      pageSize: defaultPageSize
    }),
    pagination = _useState[0],
    setPagination = _useState[1];

  // Columns are configured on child elements but rendered by the table so gather up the configs
  var columns = children.map(function (child) {
    return Object.assign({
      usePlantTime: true
    }, child.props);
  });

  // $FlowIgnore Convert the incoming sorting configs in to table component sorting format
  var defaultSortOrder = (0, _helpers.getDefaultSortOrder)(columns);
  // $FlowIgnore Convert the incoming filtering configs in to table component filtering format
  var defaultFilters = (0, _helpers.getDefaultFilters)(columns, {
    devices: devices,
    plantStateActivities: plantStateActivities
  });
  var commonDataTableProps = {
    manual: true,
    applyPagination: function applyPagination(updatedData) {
      return updatedData.slice(pagination.page * pagination.pageSize, (pagination.page + 1) * pagination.pageSize);
    },
    showPagination: true,
    page: pagination.page,
    pageSize: pagination.pageSize,
    pageSizes: [25, 50, 100, 250],
    height: height,
    width: width,
    style: {
      height: height + "px",
      width: width + "px"
    },
    defaultSorted: defaultSortOrder.map(function (_ref) {
      var id = _ref.id,
        desc = _ref.desc;
      return {
        id: id,
        desc: desc
      };
    }),
    defaultFiltered: defaultFilters,
    onFetchData: function onFetchData(_ref2) {
      var page = _ref2.page,
        pageSize = _ref2.pageSize;
      return setPagination({
        page: page,
        pageSize: pageSize
      });
    }
  };
  if (selection.isSelectionEmpty(dataRange, fetchDataOnlyOnSelection)) {
    var data = [];
    var formattedColumns = (0, _formatColumns.formatColumns)(columns, data, {
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities,
      users: users,
      ticketTypes: ticketTypes
    });
    return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, _extends({}, commonDataTableProps, {
      columns: formattedColumns,
      data: data,
      pages: 0,
      noDataText: "Make selection to view data",
      reload: function reload() {}
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_AdvancedDataTableDataProvider.AdvancedDataTableDataProvider, {
    dataSource: dataSource,
    dataRange: dataRange
  }, function (_ref3) {
    var fetching = _ref3.fetching,
      reload = _ref3.reload,
      _ref3$data = _ref3.data,
      data = _ref3$data === void 0 ? [] : _ref3$data;
    var formattedColumns = (0, _formatColumns.formatColumns)(columns, data, {
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities,
      users: users,
      ticketTypes: ticketTypes
    });
    return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, _extends({}, commonDataTableProps, {
      loading: fetching,
      columns: formattedColumns,
      data: data,
      pages: Math.ceil(data.length / pagination.pageSize),
      reload: reload
    }));
  });
});